import { useEmptyModal } from '~/hooks/useModal/modals/empty'
import BaseContainer from '~/features/paymentDesk/components/baseContainer/index.vue'
import { CertificationCompare } from '~/features/certificationCompare'

/**
 * 认证权益对比
 */
export const useVerifyCompare = (props: {
  title: string
  // user_info?: UserInfo
  // feature_type: RIGHTS_FEATURE
  // behavior: ORDER_BEHAVIOR
  // order_type: ORDER_TYPE
}) => {
  const onCancel = () => {
    model.destroy()
  }
  const { $t } = useNuxtApp()

  const model = useEmptyModal({
    closable: false,
    width: 758,
    content: h(
      BaseContainer,
      { onCancel, title: props.title, closeRefresh: true },
      () => [
        h(
          <div>
            <CertificationCompare />
            <div class="text-center mt-[24px]">
              <a-button
                type="primary"
                class="w-[162px]"
                size="large"
                onClick={onCancel}
              >
                {$t('wo-zhi-dao-le')}
              </a-button>
            </div>
          </div>,
          props
        ),
      ]
    ),
  })
}
